import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	titlecontainer: {
		display       : "flex",
		flexDirection : "column",
		padding       : "1rem 0"
	},
	titleBroadcast: {
		textAlign       : "left",
		display         : "-webkit-box",
		marginBottom    : "2px",
		paddingBottom   : "2px",
		WebkitBoxOrient : "vertical",
		WebkitLineClamp : "5",
		overflow        : "hidden",
		maxWidth        : "fit-content"
	},
	stats: {
		// color: "#757575 !important"
	},
	ellipsis: {
		width           : "4px",
		height          : "4px",
		borderRadius    : "50%",
		backgroundColor : theme.other.colors.text.secondary,
		margin          : "0rem 0.7rem"
	},
	statsContainer: {
		display    : "flex",
		alignItems : "center",
		flexWrap   : "wrap"
	},

	statsText: {
	}
} ) );
